var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.freeSamplePacks
    ? _c(
        "v-container",
        { attrs: { "grid-list-xl": "", fluid: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs8: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "link",
                      attrs: {
                        fab: "",
                        fixed: "",
                        bottom: "",
                        right: "",
                        large: "",
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showModal()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("add")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-xl": "", fluid: "" } },
                        [
                          _c("v-data-iterator", {
                            attrs: {
                              items: _vm.freeSamplePacks,
                              "content-tag": "v-layout",
                              row: "",
                              wrap: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(props) {
                                    return _c(
                                      "v-flex",
                                      { attrs: { xs12: "" } },
                                      [
                                        _c(
                                          "v-list",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-list-tile",
                                              [
                                                _c("v-list-tile-content", [
                                                  _vm._v(
                                                    _vm._s(props.item.name) +
                                                      " - " +
                                                      _vm._s(
                                                        props.item.group.type
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        props.item.group.name
                                                      )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile-content",
                                                  { staticClass: "align-end" },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "primary"
                                                        }
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              1080921495
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              model: {
                value: _vm.isModalVisible,
                callback: function($$v) {
                  _vm.isModalVisible = $$v
                },
                expression: "isModalVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline grey lighten-2",
                      attrs: { "primary-title": "" }
                    },
                    [_vm._v("Add Sample Pack")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-xl": "", fluid: "" } },
                        [
                          _c("h3", { staticClass: "headline" }, [
                            _vm._v("Add Free Sample Pack")
                          ]),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Name" },
                            model: {
                              value: _vm.freeSamplePack.name,
                              callback: function($$v) {
                                _vm.$set(_vm.freeSamplePack, "name", $$v)
                              },
                              expression: "freeSamplePack.name"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.fabricGroups,
                              "item-text": "name",
                              "item-value": "_id",
                              label: "Group"
                            },
                            on: {
                              click: function($event) {
                                return _vm.getFabrics(_vm.freeSamplePack.group)
                              }
                            },
                            model: {
                              value: _vm.freeSamplePack.group,
                              callback: function($$v) {
                                _vm.$set(_vm.freeSamplePack, "group", $$v)
                              },
                              expression: "freeSamplePack.group"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "Fabric",
                              items: _vm.fabrics,
                              "item-text": "name",
                              "item-value": "_id"
                            },
                            on: {
                              change: function($event) {
                                return _vm.getColors(_vm.fabricID)
                              }
                            },
                            model: {
                              value: _vm.fabricID,
                              callback: function($$v) {
                                _vm.fabricID = $$v
                              },
                              expression: "fabricID"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { attrs: { "grid-list-xl": "", fluid: "" } },
                        [
                          _c("h3", { staticClass: "headline" }, [
                            _vm._v("Colours")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.colors,
                              "item-text": "name",
                              "item-value": "_id",
                              label: "Colors"
                            },
                            model: {
                              value: _vm.colorID,
                              callback: function($$v) {
                                _vm.colorID = $$v
                              },
                              expression: "colorID"
                            }
                          }),
                          _vm._v(" "),
                          _vm.colorID
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { small: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addColorToPack()
                                    }
                                  }
                                },
                                [_vm._v("Add Color to Pack")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        { attrs: { "grid-list-xl": "", fluid: "" } },
                        [
                          _c("h3", { staticClass: "headline" }, [
                            _vm._v("Tags")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.tags,
                              "item-text": "name",
                              "item-value": "_id",
                              label: "Tags"
                            },
                            model: {
                              value: _vm.tagID,
                              callback: function($$v) {
                                _vm.tagID = $$v
                              },
                              expression: "tagID"
                            }
                          }),
                          _vm._v(" "),
                          _vm.tagID
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { small: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addTagToPack()
                                    }
                                  }
                                },
                                [_vm._v("Add Tag to Pack")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.freeSamplePack.tags, function(tag, index) {
                        return _c("li", { key: index }, [
                          _vm._v(_vm._s(tag.label) + " "),
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              on: {
                                click: function($event) {
                                  return _vm.removeTag(index)
                                }
                              }
                            },
                            [_vm._v("Remove")]
                          )
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.saveFreeSamplePack()
                            }
                          }
                        },
                        [_vm._v("Save Free Sample Pack")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-522ac70e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-522ac70e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/freeSamplePacks/FreeSamplePacks.vue
// module id = null
// module chunks = 